module.exports = __webpack_public_path__ + "static/media/mo.012b278d.svg";